// schema/auth/forgot-password.js
// schema/auth/create-password.js
import * as Yup from "yup";
import { yString } from "@/lib/schema-helper";

/** LOGIN */
export const LoginSchema = Yup.object({
  username: yString({ aliases: ["username", "user", "email"] })
    .min(2, "Username must be at least 2 characters")
    .required("Username is required"),
  password: yString({ aliases: ["password", "pass", "pwd"] })
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
}).meta({ name: "Login" });

/** IMPERSONATE */
export const ImpersonateSchema = Yup.object({
  username: yString({ aliases: ["username", "user", "email"] })
    .min(2, "Username must be at least 2 characters")
    .required("Username is required"),
}).meta({ name: "Impersonate" });

/** CHANGE PASSWORD */
export const ChangePasswordSchema = Yup.object({
  old_password: yString({
    aliases: ["old_password", "old", "current_password"],
  })
    .min(6, "Old password must be at least 6 characters")
    .required("Old password is required"),
  password: yString({ aliases: ["password", "new_password"] })
    .min(12, "New password must be at least 12 characters")
    .required("New password is required"),
}).meta({ name: "ChangePassword" });

/**
 * FORGOT PASSWORD
 * - email required, must be valid
 * - We keep aliases so both "email" and "username" work if needed
 */
export const ForgotPasswordSchema = Yup.object({
  email: yString({ aliases: ["email", "username"] })
    .email("Invalid email address")
    .required("Email is required"),
}).meta({ name: "ForgotPassword" });

/**
 * CREATE PASSWORD
 * - email + hash required
 * - password min 6
 * - confirm matches password
 */
export const CreatePasswordSchema = Yup.object({
  email: yString({ aliases: ["email", "username"] })
    .email("Invalid email address")
    .required("Email is required"),

  hash: yString({ aliases: ["hash", "token"] }).required(
    "Invalid or expired link",
  ),

  password: yString({ aliases: ["password"] })
    .min(12, "Password must be at least 12 characters")
    .required("Password is required"),

  confirm_password: yString({ aliases: ["confirm_password", "confirm"] })
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm password is required"),
}).meta({ name: "CreatePassword" });
